import moment from 'moment';
import { getFeatureFlags } from '../app/selectors.js';
import { toVertexLogoURL } from '~/utils/transform.js';
import mapping from '~/utils/mapping.json';


const formatDate = date => moment(date).format('ll');


const transformToStore = {
    // convert list of strings to object of name/bool
    featureFlags: (feature_flags = [], state) => getFeatureFlags(state).toJS().reduce((transformed, { name }) => ({
        ...transformed,
        [name]: feature_flags.includes(name),
    }), {}),
};

/*
 * transform GET:/users/{id} response to redux store
 */
export function toStore({
    feature_flags,
    primary_email = {
        email: '',
        sso_created: false,
        validated: false,
        created: '',
        modified: '',
    },
    product_id,
    birthdate,
    created,
    modified,
    logo_id,
    logo_url,
    ...rest
}, getState) {
    const state = getState();
    primary_email.created = formatDate(primary_email.created);
    primary_email.modified = formatDate(primary_email.modified);

    return {
        primary_email,
        product_id,
        product: mapping.license.by_id[product_id],
        birthdate: formatDate(birthdate),
        created: formatDate(created),
        modified: formatDate(modified),
        logo_id,
        logo_url,
        logo: toVertexLogoURL({ logo_id, logo_url }),
        feature_flags: transformToStore.featureFlags(feature_flags, state),
        ...rest,
    };
}

// =================================================================================================================

const transformToAPI = {
    // converts object of name/bool to list of enabled feature flag strings
    featureFlags: (feature_flags = {}) => Object.entries(feature_flags).filter(([, value]) => value).map(([name]) => name),
};

/*
 * transform PATH:/users/{id} payload to redux store
 */
export function toAPI({
    feature_flags,
    ...values
}) {
    values.feature_flags = transformToAPI.featureFlags(feature_flags);

    if (!values.feature_flags.length) {
        values.reset = ['feature_flags'];
        delete values.feature_flags;
    }

    return values;
}
